import React from 'react'
import { useState } from 'react'
import './services.css'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'



function Services() {
    const [toggleState, setToggleState] = useState(0)

    const toggleTab = (index) => {
        setToggleState(index)
    }

    const { ref, inView } = useInView({threshold : 0.3})

    useEffect(() => {
        if (inView) {
            document.querySelector(".services__section__title").style.transform = " translateX(0)"
            document.querySelector(".services__section__title").style.opacity = 1
            document.querySelector(".services__section__subtitle").style.transform = " translateX(0)"
            document.querySelector(".services__section__subtitle").style.opacity = 1
            document.querySelectorAll(".services__content").forEach((item)=>{
                item.classList.remove("services__content__out__animation")
                item.classList.add("services__content__in__animation")
                item.style.opacity = 1
            })
            
        }
        else {
            document.querySelector(".services__section__title").style.transform = " translateX(150px)"
            document.querySelector(".services__section__title").style.opacity = 0
            document.querySelector(".services__section__subtitle").style.transform = " translateX(-150px)"
            document.querySelector(".services__section__subtitle").style.opacity =0
            
            document.querySelectorAll(".services__content").forEach((item)=>{
                item.classList.remove("services__content__in__animation")
                item.classList.add("services__content__out__animation")
                item.style.opacity = 0
            })
            
        }
    }, [inView])
    return (
        <section className="services section" id="services">
            <h2 ref={ref} className="section__title services__section__title" >
                Services
            </h2>
            <span ref={ref} className="section__subtitle services__section__subtitle" >What I offer</span>



            <div ref={ref} className="services__container container grid">
                <div className="services__content ">
                    <div>
                        <i className="uil uil-web-grid services__icon"></i>
                        <h3 className="services__title">Frontend Web <br /> Developer</h3>

                    </div>

                    <span className="services__button" onClick={() => toggleTab(1)}>View More<i className="uil uil-arrow-right services__button-icon"></i></span>

                    <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Frontend Web Developer</h3>

                            <p className="services__modal-description">
                                Service with more than 3 years of experience. Providing quality work to clients and companies.
                            </p>

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I develop websites according to user/company needs.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        Webpage Development.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I create UX element interactions.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I position your company brand.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        Design,develop and mockups of products for companies.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="services__content ">
                    <div>
                        <i className="uil uil-arrow services__icon"></i>
                        <h3 className="services__title">Ui/Ux <br /> Designer</h3>

                    </div>

                    <span className="services__button" onClick={() => toggleTab(2)}>View More<i className="uil uil-arrow-right services__button-icon"></i></span>

                    <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Ui/Ux Desginer</h3>

                            <p className="services__modal-description">
                                Service with more than 2 years of experience. Providing quality work to clients and companies.
                            </p>

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I develop the user Interface.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        Webpage Development.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I create UX element interactions.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I position your company brand.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        Design and mockups of products for companies.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>


                <div className="services__content " >
                    <div>
                        <i className="uil uil-edit services__icon"></i>
                        <h3 className="services__title">Backend <br /> Developer</h3>

                    </div>

                    <span className="services__button" onClick={() => toggleTab(3)}>View More<i className="uil uil-arrow-right services__button-icon"></i></span>

                    <div className={toggleState === 3 ? "services__modal active-modal" : "services__modal"}>
                        <div className="services__modal-content">
                            <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>

                            <h3 className="services__modal-title">Backend <br /> Developer</h3>

                            <p className="services__modal-description">
                                Service with more than 2 years of experience. Providing quality work to clients and companies.
                            </p>

                            <ul className="services__modal-services grid">
                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I can develop complex backend application.
                                    </p>
                                </li>

                                <li className="services__modal-service">
                                    <i className="uil uil-check-circle services__modal-icon"></i>
                                    <p className="services__modal-info">
                                        I use Mongo DB as my choice of database.
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Services